// extracted by mini-css-extract-plugin
export default {"root":"ReportsPanelContent_root__8aTMX","blocks":"ReportsPanelContent_blocks__9rXZy","content":"ReportsPanelContent_content__lXUhD","toolbar":"ReportsPanelContent_toolbar__bGDp+"};